import { render, staticRenderFns } from "./ForgetForm.vue?vue&type=template&id=19e2488e"
import script from "./ForgetForm.vue?vue&type=script&lang=js"
export * from "./ForgetForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports